export enum TakeLeaveType {
  CasualAnnualLeave,
  SabbaticalLeave,
  UnpaidLeave,
  SickLeave,
  BereavementLeave,
  MaternityLeave,
  PaternityLeave,
  MilitaryLeave,
  GiftLeave,
  SelfQuarantineLeave,
  Other
}
